import {combineReducers, createStore} from "redux";
import {accountReducer} from "./account/AccountReducer";
import {profileReducer} from "./profile/ProfileReducer";
import {addressesReducer} from "./addresses/AddressesReducer";
import {creditsReducer} from "./credits/CreditsReducer";
import {splashInfoReducer} from "./splash-info/SplashInfoReducer";
import {splashEmergencyReducer} from "./splash-emergency/SplashEmergencyReducer";
import {infoReducer} from "./info/InfoReducer";
import {basketReducer} from "./basket/BasketReducer";
import {categoriesReducer} from "./categories/CategoriesReducer";
import {checkoutReducer} from "./checkout/CheckoutReducer";
import {emergencyReducer} from "./emergency/EmergencyReducer";
import {optionsReducer} from "./options/OptionsReducer";
import {promotionsReducer} from "./promotions/PromotionsReducer";
import {themeReducer} from "./theme/ThemeReducer";
import {walletReducer} from "./wallet/WalletReducer";
import {stampCardsReducer} from "./stamp-cards/StampCardsReducer";
import {myStampCardsReducer} from "./my-stamp-cards/MyStampCardsReducer";
import {refreshOrderDetailReducer} from "./refresh-order-detail/RefreshOrderDetailReducer";
import {productSuggestionsReducer} from "./product-suggestions/ProductSuggestionsReducer";

export const reduxStore = createStore(
    combineReducers({
        account: accountReducer,
        profile: profileReducer,
        addresses: addressesReducer,
        credits: creditsReducer,
        wallet: walletReducer,
        splashInfo: splashInfoReducer,
        splashEmergency: splashEmergencyReducer,
        info: infoReducer,
        basket: basketReducer,
        categories: categoriesReducer,
        checkout: checkoutReducer,
        emergency: emergencyReducer,
        options: optionsReducer,
        promotions: promotionsReducer,
        stampCards: stampCardsReducer,
        productSuggestions: productSuggestionsReducer,
        myStampCards: myStampCardsReducer,
        theme: themeReducer,
        refreshOrderDetail: refreshOrderDetailReducer,
    })
);
